import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { angleDoubleRight } from '@primeicons/core/angle-double-right';

@Component({
    selector: 'svg[data-p-icon="angle-double-right"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class AngleDoubleRight extends CoreIcon {
    constructor() {
        super();
        this._icon = angleDoubleRight;
    }
}
